/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

// material-ui
import makeStyles from "@material-ui/styles/makeStyles";
import Card from "@material-ui/core/Card";

import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";

// icons
import NextIcon from "@material-ui/icons/NavigateNext";

// jaza-soft
import { PageFooter, PageHeader, Button, WithReduxForm, BackButton, translate } from "jazasoft";
import MuiTable from "../../../components/MuiTable";

// local
import CardHeader from "../../../components/CardHeader";

// helpers
import getDefaultValue from "../../../utils/getDefaultValue";
import useCreateEdit from "./useCreateEdit";

import useQuery from "../../../hooks/useQuery";
import hasPrivilege from "../../../utils/hasPrivilege";
import Forbidden from "../../../components/Forbidden";
import ResourceId from "../../../utils/ResourceId";
import { Scope } from "../../../constants";

import BasicDetails from "./BasicDetails";
import { useEntityPrivilege } from "../../../hooks";

const useStyles = makeStyles(theme => ({
  content: {
    margin: theme.spacing(3)
  },
  marginVertical: {
    marginTop: "1em",
    marginBottom: "2em"
  },
  pageFooter: {
    "& > button": {
      marginRight: theme.spacing(2)
    }
  }
}));

const OrderCreate = props => {
  const { i18nKey, translate, roles, hasAccess } = props;

  const classes = useStyles();
  const { disableCreate } = useEntityPrivilege("order");

  const { orderFields, orderValidationRule, saving, columns, rows, showChildAddAction, onChange, onSubmit } = useCreateEdit(props);

  const { data: customerList = [] } = useQuery({ url: "customers", params: { size: 10 } });
  const { data: seasonList = [] } = useQuery({ url: "seasons", params: { size: 10 } });

  let ffHandleSubmit;
  const handleSubmitRef = submit => {
    ffHandleSubmit = submit;
  };

  let initialValues = getDefaultValue(orderValidationRule);

  if (customerList?.length === 1) {
    initialValues = { ...initialValues, customerId: customerList[0].id };
  }
  if (seasonList?.length === 1) {
    initialValues = { ...initialValues, seasonId: seasonList[0].id };
  }

  if (!hasPrivilege(roles, hasAccess, ResourceId.ORDER, Scope.WRITE) || disableCreate) {
    return <Forbidden history={props.history} />;
  }

  return (
    <div>
      {/** Header Element */}
      <PageHeader title="resources.orders.pageHeader.create" titleArgs={{ _: "Create Order" }} />

      {/* Main Content */}
      <div className={classes.content}>
        <WithReduxForm initialValues={initialValues}>
          {({ handleSubmit }) => (
            <div>
              {/* Basic Details */}
              <BasicDetails
                className={classes.marginVertical}
                title={translate(`resources.orders.cardHeader.basicDetails`, { _: "Basic Details" })}
                fields={orderFields}
                validationRule={orderValidationRule}
                i18nKey={i18nKey}
                editing
              />

              <Card className={classes.marginVertical}>
                <CardHeader title={translate(`resources.orders.cardHeader.flowInfo`, { _: "Flow Info" })} />
                <Divider />
                <div>
                  <MuiTable
                    columns={columns}
                    rows={rows}
                    component="div"
                    editable
                    editing
                    showEditableActions
                    rowAddCount={1}
                    // onRowAdd={(rows, rowIdx) => (!isEmpty(rowIdx) ? rows[rowIdx] : rows[rows?.length - 1])}
                    onRowAdd={(rows, rowIdx, { productId, ...row }) => row}
                    handleSubmitRef={handleSubmitRef}
                    onChange={onChange}
                    // validate={onValidate}
                    onSubmit={onSubmit}
                    showChildAddAction={showChildAddAction}
                    idKey="key"
                    parentIdKey="parentKey"
                    i18nKey="resources.orders.fields.flowInfo"
                  />
                </div>
              </Card>

              {/* Footer */}
              <PageFooter className={classes.pageFooter}>
                <BackButton label={translate("js.action.back", { _: "Back" })} variant="outlined" color="primary" />
                <Button
                  label={translate("resources.orders.action.next", { _: "NEXT" })}
                  color="primary"
                  variant="contained"
                  disabled={saving}
                  onClick={event => {
                    handleSubmit(() => {})();
                    ffHandleSubmit(event);
                  }}>
                  <NextIcon />
                  {saving && <CircularProgress size={20} thickness={2} />}
                </Button>
              </PageFooter>
            </div>
          )}
        </WithReduxForm>
      </div>
    </div>
  );
};

export default translate(OrderCreate);
